module.exports = __webpack_public_path__ + "img/s00174.2a75e088.png";